import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as mlSavedDashboardActions from '@store/metricLens/dashboard/actions';
import { initTempDashboard } from '@store/metricLens/tempDashboard/actions';
import tempDashboardStateSelector from '@store/metricLens/selectors';
import tempDashboardSelector from '@store/metricLens/tempDashboard/selectors';
import {
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
} from '@store/metricLens/dashboard/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import dashboard from '../../common/dashboard';
import MLDashboard from '../MetricLensDashboard';
import injectorServer from '../../common/injectorServer';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardStateSelector,
  tempDashboardSelector,
  (response, isFetching, dashboardState, tempDashboard) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.ML,
    dashboard: dashboardState,
    tempIsFetching: tempDashboard.isFetching,
  }),
);

const MLSavedDashboard = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: mlSavedDashboardActions.initRequest,
    getDashboard: mlSavedDashboardActions.getDashboard,
    fetchingAction: mlSavedDashboardActions.fetching,
  }),
  dashboard(),
)(MLDashboard);

export default injectorServer({}, { pageType: PAGE_TYPE.SAVED_DASHBOARD })(MLSavedDashboard);
